module.exports = {
  interpolate: require('./interpolate')
};